<template>
    <div class="tabcontent">
        <v-row justify="space-between">
            <v-col cols="12" md="8" sm="12">
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-subheader>Организация</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="IdOrg"
                                        :items="orglist"
                                        @input="changeOrg"
                                        required
                                        :dense="true"
                                        :disabled="this.id > 0"
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-subheader>Объект</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="IdHouse"
                                        :items="houselist"
                                        required
                                        :dense="true"
                                        :disabled="this.id > 0"
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row >
                      <v-col cols="12" md="4">
                        <v-subheader>Вид</v-subheader>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                        >
                          <v-select
                              v-model="type"
                              :items="typeszayav"
                              :dense="true"
                              @input="changeType"
                              :disabled="this.id > 0"
                          ></v-select>
                        </v-skeleton-loader>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-subheader>Статья</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                            <v-combobox
                                    v-model="IdStatii"
                                    :items="statilist"
                                    @input="changeStatii"
                                    :dense="true"
                                    :disabled="this.id > 0"
                            >
                                <template #item="{ item }">
                                    <div :class="item.layer == 1 ? 'ml-2 font-weight-medium' : (item.layer == 2 ? 'ml-4' : 'font-weight-bold')">
                                        {{ item.text }}
                                    </div>
                                </template>
                            </v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-subheader>Период</v-subheader>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select
                                    v-model="yearbdds"
                                    :items="yearfilter"
                                    v-if="this.id == 0"
                            ></v-select>
                            <div v-if="this.id > 0">{{ yearbdds }}</div>
                        </v-col>
                    </v-row>

                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                      <!--
                      <v-row v-show="type == 0">
                        <v-col cols="12" md="4">
                          <v-subheader>Сумма планируемых поступлений</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                          <v-text-field
                              v-model="SummPostup"
                              :counter="10"
                              :rules="summaRules"
                              :dense="true"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      -->
                        <v-checkbox v-show="type == 1" v-model="UseLimit" class="mx-2" label="Лимит расходов"></v-checkbox>
                    </v-skeleton-loader>
                    <v-row v-show="UseLimit === true">
                        <v-col cols="12" md="4">
                            <v-subheader>Сумма лимита</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field
                                    v-model="Summ"
                                    :counter="10"
                                    :rules="summaRules"
                                    :dense="true"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-checkbox v-show="type == 1" v-model="NeedSoglasovan" class="mx-2" label="Требует согласования"></v-checkbox>
                    <v-row>
                        <v-col cols="12" md="4"></v-col>
                        <v-col cols="12" md="8">
                            <v-btn color="primary" class="mr-4" @click="saveStatii">
                                Сохранить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar
                v-model="snackbarresult"
                :timeout="resulttimeout"
        >
            {{ resulttext }}
        </v-snackbar>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js'

    export default {
        name: "BddsAddStatii",
        props: ['id', 'IdOrgDef', 'IdHouseDef'],
        mounted() {
            this.$store.dispatch('GET_ORG_LIST', {});
            /*this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg ? this.IdOrg : 0, IdHouse: this.IdHouse ? this.IdHouse : -1}).then(() => {
                if (this.id > 0) {
                    this.LoadData();
                } else {
                    this.loading = false;
                }
            });*/
            if (this.id > 0) {
              this.LoadData();
            } else {
              this.loading = false;
            }
            bus.$on('refreshTabBddsAddStatii'+this.id, this.refreshHandler);
        },
        data() {
            return {
                loading: true,
                valid: true,
                type: 0,
                IdOrg: localStorage.getItem('idtsg'),
                IdHouse: '',
                IdStatii: '',
                Summ: 0,
                SummPostup: 0,
                summaRules: [
                    v => !!v || 'Введите сумму',
                    v => (v && v.length <= 10) || 'Сумма не более 10 символов',
                ],
                UseLimit: false,
                typeszayav: [
                    {value: 0, text: 'Поступления'},
                    {value: 1, text: 'Расходы'}
                ],
                yearbdds: new Date().getFullYear(),
                NeedSoglasovan: false,
                snackbarresult: false,
                resulttimeout: 2000,
                resulttext: '',
            }
        },
        computed: {
            orglist() {
                let orglist = this.$store.getters.ORG ? this.$store.getters.ORG.orglist : null;
                let ret = [];
                if (orglist) {
                  if(localStorage.getItem('idtsg')>0){
                    this.$store.getters.ORG.orglist.forEach((item) => {
                      if(item.ID == localStorage.getItem('idtsg'))
                        ret.push({value: item.ID, text: item.Name});
                    });
                  }else{
                    this.$store.getters.ORG.orglist.forEach((item) => {
                      ret.push({value: item.ID, text: item.Name});
                    });
                  }
                }
                return ret;
            },
            houselist() {
                let houselist = this.$store.getters.HOUSE ? this.$store.getters.HOUSE.houselist : null;
                let ret = [{value: 0, text: 'Все'}];
                const IdOrg = this.IdOrg ? this.IdOrg.value : 0;
                if (houselist && IdOrg > 0) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(houselist).forEach(([key, item]) => {
                        //if (IdOrg == item.IdTsj) {
                            ret.push({value: item.ID, text: item.Name});
                        //}
                    });
                }
                return ret;
            },
            statilist() {
                let statilist = this.$store.getters.STATIILIST ? this.$store.getters.STATIILIST.data : null;
                let ret = [];
                if (statilist) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(statilist).forEach(([key, item]) => {
                        let NumbOne = '';
                        if(item.Numb>0)
                          NumbOne = item.Numb;
                        ret.push({text: NumbOne+' '+item.Name, value: parseInt(item.ID), layer: item.Layer, type: item.Type});
                        item.sub.forEach((itemst) => {
                          let NumbTwo = '';
                          if(itemst.Numb>0)
                            NumbTwo = NumbOne+'.'+itemst.Numb;
                            ret.push({text: NumbTwo+' '+itemst.Name, value: itemst.ID, layer: itemst.Layer, type: itemst.Type});
                            itemst.sub.forEach((itemsub) => {
                              let NumbThree = '';
                              if(itemst.Numb>0)
                                NumbThree = NumbTwo+'.'+itemst.Numb;
                                ret.push({text: NumbThree+' '+itemsub.Name, value: itemsub.ID, layer: itemsub.Layer, type: itemsub.Type});
                            });
                        });
                    });
                }
                return ret;
            },
            yearfilter() {
                let nowYear = new Date().getFullYear() + 1;
                let years = [];
                for (let i = 0; i < 5; i++) {
                    years.push(nowYear - i);
                }
                return years;
            },
        },
        methods: {
            formatCurrency(value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            fromCurrency(value) {
                value = value.replace(/\s/, '');
                value = value.replace(/,/, '.');
                return value;
            },
            changeOrg() {
                this.loading = true;
                this.IdHouse = '';
                this.$store.dispatch('GET_HOUSE_LIST', {IdOrg: this.IdOrg ? this.IdOrg.value : 0});
                this.$store.dispatch('GET_STATIILIST', {IdOrg:  this.IdOrg ? this.IdOrg.value : 0, Type: this.type}).then(() => {
                  this.loading = false;
                });
                /*this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg ? this.IdOrg.value : 0, IdHouse: this.IdHouse ? this.IdHouse.value : -1}).then(() => {
                    this.loading = false;
                });*/
            },
            changeType() {
              this.loading = true;
              this.$store.dispatch('GET_STATIILIST', {IdOrg:  this.IdOrg ? this.IdOrg.value : 0, Type: this.type}).then(() => {
                this.loading = false;
              });
            },
            changeStatii() {
               /* let statilist = this.$store.getters.ORGFILTERS ? this.$store.getters.ORGFILTERS.statilist : null;
                const IdStatii = this.IdStatii ? this.IdStatii.value : 0;
                if (statilist && IdStatii) {
                    // eslint-disable-next-line no-unused-vars
                    for (let it of Object.entries(statilist)) {
                        let item = it[1];
                        //console.log(item);
                        if (IdStatii == parseInt(item.ID)) {
                            this.type = parseInt(item.Type);
                            return;
                        }
                        for (let itemst of item.sub) {
                            if (IdStatii == itemst.ID) {
                                this.type = parseInt(itemst.Type);
                                return;
                            }
                            for (let itemsub of itemst.sub) {
                                if (IdStatii == itemsub.ID) {
                                    this.type = parseInt(itemsub.Type);
                                    return;
                                }
                            }
                        }
                    }
                }*/
            },
            LoadData() {
                this.$store.dispatch('GET_EDITSTATIIOBJ', {
                    id: this.id ? this.id : 0
                }).then(() => {
                    this.loading = false;

                    let editstatii = this.$store.getters.EDITSTATIIOBJ ? this.$store.getters.EDITSTATIIOBJ.data : null;
                    if (editstatii) {
                        this.orglist.forEach((item) => {
                            if (item.value == editstatii.IdOrg) {
                                this.IdOrg = item;
                            }
                        });
                        this.type = parseInt(editstatii.Type);
                        this.$store.dispatch('GET_HOUSE_LIST', {IdOrg: this.IdOrg ? this.IdOrg.value : 0}).then(() => {
                          this.houselist.forEach((item) => {
                            if (item.value == editstatii.IdHouse) {
                              this.IdHouse = item;
                            }
                          });
                        });
                        this.$store.dispatch('GET_STATIILIST', {IdOrg:  this.IdOrg ? this.IdOrg.value : 0, Type: this.type}).then(() => {
                          this.statilist.forEach((item) => {
                              if (item.value == editstatii.IdStatii) {
                                  this.IdStatii = item;
                              }
                          });
                          this.Year = editstatii.Year;
                          this.UseLimit = parseInt(editstatii.UseLimit) == 1 ? true : false;
                          this.Summ = this.formatCurrency(editstatii.Summ);
                          this.NeedSoglasovan = parseInt(editstatii.NeedSoglasovan) == 1 ? true : false;
                        });
                    }

                });
            },
            saveStatii () {

                if (!this.IdStatii  || !this.IdOrg || !this.IdHouse || !this.yearbdds) {
                    return;
                }

                let res;
                if (this.id) {
                    res = this.$store.dispatch('UPDATE_STATIIOBJECT', {
                        id: this.id,
                        Type: this.type,
                        UseLimit: !!this.UseLimit,
                        Summ: this.Summ ? this.fromCurrency(this.Summ) : 0,
                        Year: this.yearbdds,
                        NeedSoglasovan: !!this.NeedSoglasovan
                    });
                } else {
                    res = this.$store.dispatch('SAVE_STATIIOBJECT', {
                        IdOrg: this.IdOrg.value,
                        IdHouse: this.IdHouse.value,
                        IdStatii: this.IdStatii ? this.IdStatii.value : 0,
                        Type: this.type,
                        UseLimit: !!this.UseLimit,
                        Summ: this.Summ ? this.fromCurrency(this.Summ) : 0,
                        Year: this.yearbdds,
                        NeedSoglasovan: !!this.NeedSoglasovan
                    });
                }
                res.then(response => {
                    //console.log(this.$vnode.key);
                    if (response.status === 1) {
                        this.$parent.closeTab(this.$vnode.key, 'tabBddsPlan0');
                        bus.$emit('resetFilterhTabBddsPlan', {IdOrg: this.IdOrg.value, IdHouse: this.IdHouse.value});
                    } else {
                        this.resulttext = response.message;
                        this.snackbarresult = true;
                    }
                });
            },

            refreshHandler() {
                this.$refs.form.reset();
                this.type = '';
                if (this.id > 0) {
                    this.LoadData();
                }
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 45px;
    }
</style>